import { LucideIcon, Package, Palette, Tag } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { AddOrderProductTestIds } from '../../../../../../utils/testIds/OrderProducts.testIds';
import { AddOrderProductMode } from '../../../../products/orderProducts.types';

export interface AddProductToggleButtonProps {
  isOpen: boolean;
  mode: AddOrderProductMode;
  isModeSelectable?: boolean;
  isCompact?: boolean;
  onToggleOpen: () => void;
  onSelectMode: (mode: AddOrderProductMode) => void;
}

export const MODE_OPTIONS: {
  mode: AddOrderProductMode;
  label: LangEnum;
  description: LangEnum;
  icon: LucideIcon;
  testId: string;
}[] = [
  {
    mode: AddOrderProductMode.PRODUCT,
    label: LangEnum.GLOBAL_PRODUCT,
    description: LangEnum.ADD_ORDER_PRODUCTS_MODE_PRODUCT_DESCRIPTION,
    icon: Package,
    testId: AddOrderProductTestIds.MODE_MENU_ITEM_PRODUCT,
  },
  {
    mode: AddOrderProductMode.COLOR,
    label: LangEnum.ADD_ORDER_PRODUCTS_MODE_COLOR_LABEL,
    description: LangEnum.ADD_ORDER_PRODUCTS_MODE_COLOR_DESCRIPTION,
    icon: Palette,
    testId: AddOrderProductTestIds.MODE_MENU_ITEM_COLOR,
  },
  {
    mode: AddOrderProductMode.SKU,
    label: LangEnum.GLOBAL_SKU,
    description: LangEnum.ADD_ORDER_PRODUCTS_MODE_SKU_DESCRIPTION,
    icon: Tag,
    testId: AddOrderProductTestIds.MODE_MENU_ITEM_SKU,
  },
];
